import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Route-transition splash. Mounts a brief (≈350 ms) overlay with a
 * pulsing logo every time the path changes. Pure CSS animation, no
 * dependency. Skips the very first paint so the initial page load
 * isn't shadowed by the splash.
 */
export default function RouteSplash() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const initial = useRef(true);

  useEffect(() => {
    if (initial.current) {
      initial.current = false;
      return;
    }
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 350);
    return () => clearTimeout(t);
  }, [pathname]);

  if (!visible) return null;

  return (
    <div
      aria-hidden
      data-testid="route-splash"
      className="pointer-events-none fixed inset-0 z-[60] flex items-center justify-center bg-background/70 backdrop-blur-sm route-splash-fade"
    >
      <img
        src="/logo.png"
        alt=""
        className="h-16 w-16 object-contain route-splash-pulse"
        draggable={false}
      />
    </div>
  );
}
